import { render, staticRenderFns } from "./GStudentImportYearConfirmModal.vue?vue&type=template&id=19a40008&scoped=true&"
import script from "./GStudentImportYearConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./GStudentImportYearConfirmModal.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentImportYearConfirmModal.vue?vue&type=style&index=0&id=19a40008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a40008",
  null
  
)

export default component.exports